module.exports = "data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjM2cHgiIGhlaWdodD0iMzZweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAtMTA4IDAgKSI+DQogICAgPHBhdGggZD0iTSAxNDQgMzYgIEwgMTA4IDAgIEwgMTA4IDM2ICBMIDE0NCAzNiAgWiAiIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0iIzExYTVhNyIgc3Ryb2tlPSJub25lIiBmaWxsLW9wYWNpdHk9IjAuOTkyMTU2ODYyNzQ1MDk4MSIgLz4NCiAgPC9nPg0KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/normal_u563.svg
// module id = lSfh
// module chunks = 1